import { LogoMark } from "@/components/Logo";
import { useNavigate } from "react-router-dom";
import { scrollToId, login } from "@/lib/api";

const useCols = () => {
  const nav = useNavigate();
  const home = (id) => () => { nav("/"); setTimeout(() => scrollToId(id), 300); };
  return [
    ["Explore", [["The Hollow", home("about")], ["Bracelets", home("shop")], ["Thought wall", () => nav("/thoughts")]]],
    ["Account", [["Sign in", login]]],
  ];
};

export const Footer = () => {
  const COLS = useCols();
  return (
  <footer className="relative border-t border-purple-400/15 pt-20 pb-10 overflow-hidden bg-[#0b0512]" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <div className="flex items-center gap-3"><LogoMark className="w-10 h-10" /><span className="font-display text-2xl uppercase tracking-[0.2em] text-[#f6e7c1]">Lavender Hollow</span></div>
          <p className="mt-5 max-w-sm text-purple-100/85 leading-relaxed">
            Handmade bracelets by Liza Zhen, and a quiet place to share what's on your mind.
          </p>
        </div>
        {COLS.map(([title, links]) => (
          <div key={title} className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-amber-200">{title}</p>
            <ul className="mt-5 space-y-3">
              {links.map(([label, fn]) => (
                <li key={label}>
                  <button onClick={fn} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-purple-100 hover:text-white transition-colors">{label}</button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="mt-20 font-display text-[16vw] lg:text-[10rem] leading-[0.8] tracking-tight text-purple-200/15 select-none" aria-hidden="true">
        Lavender <em>Hollow</em>
      </p>
      <div className="mt-8 pt-6 border-t border-purple-400/15 flex flex-col md:flex-row justify-between gap-3 text-sm text-purple-200">
        <span>© {new Date().getFullYear()} Lavender Hollow. All rights reserved.</span>
        <span>Payments secured by Stripe</span>
      </div>
    </div>
  </footer>
  );
};
